import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboardService } from '../service/dashboard.service';
import { Router } from '@angular/router';
import { MatTableDataSource, MatPaginator, MatDialog, MatSlideToggleChange,MatSnackBar } from '@angular/material';
import { UpdateAdminComponent } from 'src/app/dialogs/update-admin/update-admin.component';

import { UpdateBrokerComponent } from 'src/app/dialogs/update-broker/update-broker.component';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Component({
  selector: 'app-brokers',
  templateUrl: './brokers.component.html',
  styleUrls: ['./brokers.component.scss']
})

export class brokersComponent implements OnInit {

  currentUser;
  allBrokers: any = [];
  searchdata;


  length: number = 0
  pageIndex: number = 0
  pageSize: number = 5
  pageSizeOptions = [5, 10, 20, 50, 100]

  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource();
  displayedColumns = ['no', 'id', 'firstName', 'lastName', 'email', 'phone', 'company', 'edit', 'status','refresh']


  isActive = true;
  accountStatus = "disabled"
  pageChange = false;

  constructor(
    public service: DashboardService,
    public router: Router,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }



  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('userdata'))
    this.fetchBrokers();
    this.pageChange = false;

  }


  getRequestParams(current_page, page_size) {
    let params = {};

    params[`email`] = this.currentUser.email
    params[`role`] = this.currentUser.role

    if (current_page) {
      params[`current_page`] = current_page
    }

    if (page_size) {
      params[`page_size`] = page_size
    }

    return params;
  }


  fetchBrokers() {

    const params = this.getRequestParams(this.pageIndex + 1, this.pageSize)
    console.log("params>>>> " + JSON.stringify(params))

    if (this.pageChange) {
      //don't show loading 
    } else {
      Swal.showLoading();
    }


    this.service.getBrokers(JSON.stringify(params))
      .toPromise()
      .then((response: any) => {
        Swal.close()
        if (response.hasOwnProperty('responseCode') && response.responseCode == '000') {

          this.allBrokers = response.page.records
          this.dataSource.data = this.allBrokers
          //this.dataSource.paginator = this.paginator;
          //this.pageIndex = response.page.current
          this.pageSize = response.page.size
          this.length = response.page.total
          //this.iterator();


          // this.searchdata = this.allBrokers;
          // this.dataSource.paginator = this.paginator;

        } else {
          this.dataSource.data = [];
        }


      })
      .catch(error => {
        (Swal as any).fire({
          title: 'Retrieval Failed',
          text: 'Failed to retrieve policy details',
          icon: 'error'
        })
      })
      .finally(() => {
        Swal.close()
      })


    //this.service.getBrokers(JSON.stringify(params)).subscribe(data => {
    // console.log(JSON.stringify(data['page'][0]['total']=data['total'] ))

    // this.allBrokers = data['responseData'];
    // this.dataSource.data = this.allBrokers;
    // this.searchdata = this.allBrokers;
    // this.dataSource.paginator = this.paginator;


  }

  updateBrokerStatus(status, data) {

    const requestPayload = {
      broker_user_code: data.broker_user_code,
      broker_user_status: status === true ? `1` : `0`,
      broker_user_modified_by: this.currentUser.email,
    }

    console.log(requestPayload);


    Swal.showLoading();
    this.service.disableBroker(requestPayload)
      .subscribe(response => {
        console.log(response);

        Swal.close();
        if (response['responseCode'] === '000') {
          this.fetchBrokers();

          (Swal as any).fire({
            icon: 'success',
            title: 'Successful',
            text: status === true ? `Broker user account activated` : `Broker user account disabled`,
          });


        } else {
          (Swal as any).fire({
            icon: 'warning',
            title: 'Oops...',
            text: response['responseMessage'],
            footer: ''
          });
        }

      }, error => {
        (Swal as any).fire({
          icon: 'error',
          title: 'Oops...',
          text: error,
          footer: ''
        });
        Swal.close();
      })



  }

  search(query: string) {
    this.searchdata = (query) ? this.allBrokers.filter(data => data.broker_user_code.toLowerCase().includes(query.toLowerCase()) || data.broker_user_last_name.toLowerCase().includes(query.toLowerCase()) || data.broker_user_first_name.toLowerCase().includes(query.toLowerCase()) || data.broker_user_email.toUpperCase().includes(query.toUpperCase())) : this.allBrokers;
  }


  addBroker() {
    this.router.navigate(['/add-broker'])
  }


  brokers() {
    this.router.navigate(['/brokers'])
  }

  openEditDialog(selectedRow) {
    console.log(selectedRow);

    const dialogRef = this.dialog.open(UpdateBrokerComponent, {
      disableClose: true,
      data: selectedRow
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'updated') {
        this.fetchBrokers();
      }

    });

  }



  updateActiveStatus(event: MatSlideToggleChange, element) {
    console.log(event.checked);
    console.log(element);

    (Swal as any).fire({
      title: '',
      text: event.checked === false ? `Do you want to disable this user account?` : `Do you want to activate this user account?`,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No, thanks!',
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (result.value) {

        this.updateBrokerStatus(event.checked, element)

      } else {
        result.dismiss === Swal.DismissReason.cancel
        this.fetchBrokers();
      }

    })


  }


  handlePageChange(event) {
    console.log("pageIndex>>>> " + event.pageIndex)
    console.log("pageSize>>>> " + event.pageSize)

    this.pageIndex = event.pageIndex
    this.pageSize = event.pageSize

    this.pageChange = true;
    this.fetchBrokers()
   


  }


  // pin reset 

    //confirm login Password to continue
    confirmPassword(broker_admin){
      (Swal as any).fire({
        icon:"question",
        allowOutsideClick:false,
        showCancelButton: true,
        text:"Do you really want to reset this broker user's pin?",
        reverseButtons: true
      }).then((result:SweetAlertResult)=>{
        if(result.value){
          (Swal as any).fire({
            //title: "Identity Confirmation",
            icon:"warning",
            allowOutsideClick:false,
            showCancelButton: true,
            inputPlaceholder: "Confirm your Password",
            input:"password",
            reverseButtons: true
          })
          .then((result:SweetAlertResult)=>{
               if(result.value){
                  Swal.showLoading();
                  this.service.getLogin({
                    email:this.currentUser.email,
                    password:result.value,
                    role:'admin'
                  })
                  .toPromise()
                  .then((responseData: any)=>{
                    Swal.close();
                    if(responseData.hasOwnProperty('responseCode') && responseData.responseCode==='000'){
                        this.openReset(broker_admin)
                    }
                    else{
                      (Swal as any).fire({
                        title: 'Wrong credentials!',
                        text: 'Please check and try again',
                        icon: 'error',
                      });
                      setTimeout(()=>{this.confirmPassword(broker_admin)},2000);
                    }
    
                  }).catch(error=>{
                    (Swal as any).fire({
                      title: 'Connection Failed!',
                      text: 'Login Failed',
                      icon: 'error',
                    });
                    setTimeout(()=>{this.confirmPassword(broker_admin)},2000);
                  })
               }
               else
               this.alertSnackBar('No Password was entered','User Not Verified');
             });
        }
      })
    
       }
          //trigger the snackbar
          alertSnackBar(message: string, action: string) {
            this._snackBar.open(message, action, {
              duration: 2000,
            });
        }
    
    
    
        openReset(broker_user){
       //   console.log('selected',broker_admin)
          let payload={
            broker_user_code:broker_user.broker_user_code,
            broker_user_modified_by:this.currentUser.email,
          //  module: 'agent',
            role: "admin",
          }
          this.service.resetBRokerUserPin(payload).subscribe((response:any)=>{
             if(response.responseCode=='000')
             (Swal as any).fire({
               icon:'info',
               text:'Account Reset Mail Sent Successfully!'
             });
             else
             (Swal as any).fire({
              icon:'error',
              text:'Account Reset failed!'
            });
          })
          }
    




  private iterator() {
    const end = (this.pageIndex + 1) * this.pageSize;
    const start = this.pageIndex * this.pageSize;
    const part = this.allBrokers.slice(start, end);
    this.dataSource = part;
  }



}
